const APP_NAME = "Lifting"
const ROUTE_PREFIX = "/pwa-lifting"


export {APP_NAME, ROUTE_PREFIX};